// extracted by mini-css-extract-plugin
export default {"label":"SourceMessage_label__NWkKM","source":"SourceMessage_source__iqWtG","relevantSource":"SourceMessage_relevantSource__8yxHx"};